// A photo as a surface (a cast's PHOTO item): the image in the frame. It never ends by itself.
import { useState } from "react";
import { useTranslation } from "react-i18next";
import type { SurfaceProps } from "../PlayableMedia";
import { ErrorOverlay, Frame, useEmit } from "./shared";
import { useImageSrc } from "../../hooks/useImageSrc";

export default function PhotoSurface(p: SurfaceProps) {
  const { t } = useTranslation();
  const { url, kind } = p;
  const emit = useEmit(p);
  // The url that failed: a new url shows no error from the first render on.
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const failed = failedUrl === url;
  // A HEIC shows on every browser (lib/heicImage); events still key by `url`.
  const shown = useImageSrc(url);
  const img = (
    <img
      key={url}
      src={shown}
      alt={kind.label(t)}
      data-testid={p.hostTestId}
      onLoad={() => {
        setFailedUrl(null);
        emit({ type: "loaded", key: url });
      }}
      onError={() => {
        setFailedUrl(url);
        emit({ type: "error", key: url });
      }}
      className={p.hostClassName ?? "w-full h-full object-contain"}
    />
  );
  return <Frame frame={p.frame} media={img} overlays={failed && p.showError ? <ErrorOverlay /> : null} />;
}
